// Author Lidongxu
// Date 2025-05-27 10:46:54

class EmEpcBindHis {
    constructor({
                    id = null,
                    remark = '',
                    epcCode = '',
                    operation = '',
                    tagBusinessCode = '',
                    bindId = '',
                    operatorId = '',
                    operateTime = ''
                }
                = {}) {
        this.id = id;
        this.remark = remark;
        this.epcCode = epcCode;
        this.operation = operation;
        this.tagBusinessCode = tagBusinessCode;
        this.bindId = bindId;
        this.operatorId = operatorId;
        this.operateTime = operateTime;
    }
}

function newEntity() {
    return new EmEpcBindHis();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.epc.emEpcBindHis.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.epc.emEpcBindHis.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'epcCode',
            label: 'label.em.epc.emEpcBindHis.grid.epcCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operation',
            label: 'label.em.epc.emEpcBindHis.grid.operation',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '绑定'},
                    {value: '1', text: '解绑'}
                ]
            }
        },
        {
            key: 'tagBusinessCode',
            label: 'label.em.epc.emEpcBindHis.grid.tagBusinessCode',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '工具/刀具'},
                    {value: '2', text: '吊索具'},
                    {value: '3', text: '固定资产'},
                    {value: '4', text: '工装'},{value: '5', text: '量器具'}
                ]
            }
        },
        {
            key: 'bindId',
            label: 'label.em.epc.emEpcBindHis.grid.bindId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operatorId',
            label: 'label.em.epc.emEpcBindHis.grid.operatorId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operator',
            label: 'label.em.epc.emEpcBindHis.grid.operator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operateTime',
            label: 'label.em.epc.emEpcBindHis.grid.operateTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    epcCodeFilter: '',
    operationFilter: '',
    tagBusinessCodeFilter: '',
    bindIdFilter: '',
    operatorIdFilter: '',
    operateTimeRteFilter: '',
    operateTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'epcCodeFilter',
        label: 'label.em.epc.emEpcBindHis.filter.epcCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationFilter',
        label: 'label.em.epc.emEpcBindHis.filter.operation',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '绑定'},
                {value: '1', text: '解绑'}
            ]
        }
    },
    {
        key: 'tagBusinessCodeFilter',
        label: 'label.em.epc.emEpcBindHis.filter.tagBusinessCode',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工具/刀具'},
                {value: '2', text: '吊索具'},
                {value: '3', text: '固定资产'},
                {value: '4', text: '工装'},{value: '5', text: '量器具'}
            ]
        }
    },
    {
        key: 'bindIdFilter',
        label: 'label.em.epc.emEpcBindHis.filter.bindId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operatorIdFilter',
        label: 'label.em.epc.emEpcBindHis.filter.operatorId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTimeRteFilter',
        label: 'label.em.epc.emEpcBindHis.filter.operateTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTimeLteFilter',
        label: 'label.em.epc.emEpcBindHis.filter.operateTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'remark',
        label: 'label.em.epc.emEpcBindHis.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'epcCode',
        label: 'label.em.epc.emEpcBindHis.entity.epcCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operation',
        label: 'label.em.epc.emEpcBindHis.entity.operation',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '绑定'},
                {value: '1', text: '解绑'}
            ]
        }
    },
    {
        key: 'tagBusinessCode',
        label: 'label.em.epc.emEpcBindHis.entity.tagBusinessCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工具/刀具'},
                {value: '2', text: '吊索具'},
                {value: '3', text: '固定资产'},
                {value: '4', text: '工装'},{value: '5', text: '量器具'}
            ]
        }
    },
    {
        key: 'bindId',
        label: 'label.em.epc.emEpcBindHis.entity.bindId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operatorId',
        label: 'label.em.epc.emEpcBindHis.entity.operatorId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTime',
        label: 'label.em.epc.emEpcBindHis.entity.operateTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    EmEpcBindHis, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
